import React from 'react'
import _ from 'lodash/fp'

import MUIButton from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

import colors from '@fe/ui/colors'

const Button = ({
  disabled,
  loading,
  style,
  startIcon,
  endIcon,
  loaderRight,
  ...props
}) => {
  const color = disabled ? undefined : { color: _.get('color', style) || colors.primaryLightGreen }
  const loaderIcon = (<CircularProgress style={{ ...color }} size={22} />)
  const isDisabled = disabled || loading

  const startIconOrLoader = loading && !loaderRight
    ? loaderIcon
    : startIcon

  const endIconOrLoader = loading && loaderRight
    ? loaderIcon
    : endIcon

  return (
    <MUIButton
      style={{ fontWeight: '600', ...color, ...style }}
      startIcon={startIconOrLoader}
      endIcon={endIconOrLoader}
      disabled={isDisabled}
      {...props}
    />
  )
}

export default Button
